import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";
import { IAdminUser } from "./useAllAdminUsers";

const getAdminUser = async (
  ssoUserId: string,
): Promise<IResponse<IAdminUser>> => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_ADMIN_USER}?ssoUserId=${ssoUserId}`,
  );
  return data;
};

export default function useGetAdminUser(ssoUserId: string | null | undefined) {
  return useQuery<IResponse<IAdminUser>, Error>(
    [ssoUserId, "getAdminUser"],
    getAdminUser,
    {
      enabled: !!ssoUserId,
      refetchOnWindowFocus: false,
    },
  );
}
